import { render } from "./RejectionReason.vue?vue&type=template&id=228b0f5e&scoped=true"
import script from "./RejectionReason.vue?vue&type=script&lang=js"
export * from "./RejectionReason.vue?vue&type=script&lang=js"

import "./RejectionReason.vue?vue&type=style&index=0&id=228b0f5e&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228b0f5e"],['__file',"src/views/pre/survey/RejectionReason.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "228b0f5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('228b0f5e', __exports__)) {
    console.log('reload')
    api.reload('228b0f5e', __exports__)
  }
  
  module.hot.accept("./RejectionReason.vue?vue&type=template&id=228b0f5e&scoped=true", () => {
    console.log('re-render')
    api.rerender('228b0f5e', render)
  })

}


export default __exports__